'use client';

import { Suspense, useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Chatbot from '@/components/common/Chatbot';
import OrderForm from './components/OrderForm';
import ServiceSelector from './components/ServiceSelector';
import { analytics } from '@/lib/analytics';

function OrderContent() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid lg:grid-cols-3 gap-8">
        {/* Order Form */}
        <div className="lg:col-span-2">
          <OrderForm />
        </div>

        {/* Service Selector */}
        <div className="lg:col-span-1">
          <ServiceSelector />
        </div>
      </div>
    </div>
  );
}

export default function OrderPage() {
  useEffect(() => {
    analytics?.trackPageView('/order');
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-24">
        {/* Page Header */}
        <div className="bg-gradient-to-br from-primary/5 to-secondary/5 py-12 border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
              Book Your Shipment
            </h1>
            <p className="text-lg text-muted-foreground">
              Fast, reliable shipping with real-time tracking to any destination
            </p>
          </div>
        </div>

        <Suspense fallback={
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="bg-muted rounded-xl p-12 text-center">
              <p className="text-muted-foreground">Loading order form...</p>
            </div>
          </div>
        }>
          <OrderContent />
        </Suspense>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}